
import environment from "../configurations/environment";
import httpClientImpl from "./http";
import authClientImpl from "./auth";
import restClientImpl from "./rest";

export const AuthClient = authClientImpl(environment.api);
export const HttpClient = httpClientImpl(AuthClient);
export const RestClient = restClientImpl(environment.api, HttpClient);
